"use strict";
// Originally from https://github.com/pose/webcrypto-jwt
// (C) Copyright (c) 2015 Alberto Pose albertopose@gmail.com
// Used under the terms of the MIT License (https://github.com/pose/webcrypto-jwt/blob/master/LICENSE.md)
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebCryptoJWT = void 0;
var base64url_1 = require("./base64url");
var utils_1 = require("./utils");
var common_1 = require("../common");
var ALGORITHMS = {
    none: {},
    HS256: {
        importKey: {
            name: 'HMAC',
            hash: 'SHA-256'
        },
        operation: {
            name: 'HMAC',
            hash: 'SHA-256'
        }
    },
    HS384: {
        importKey: {
            name: 'HMAC',
            hash: 'SHA-384'
        },
        operation: {
            name: 'HMAC',
            hash: 'SHA-384'
        }
    },
    HS512: {
        importKey: {
            name: 'HMAC',
            hash: 'SHA-512'
        },
        operation: {
            name: 'HMAC',
            hash: 'SHA-512'
        }
    },
    RS256: {
        importKey: {
            name: 'RSASSA-PKCS1-v1_5',
            hash: 'SHA-256'
        },
        operation: {
            name: 'RSASSA-PKCS1-v1_5',
            hash: 'SHA-256'
        }
    },
    RS512: {
        importKey: {
            name: 'RSASSA-PKCS1-v1_5',
            hash: 'SHA-512'
        },
        operation: {
            name: 'RSASSA-PKCS1-v1_5',
            hash: 'SHA-512'
        }
    },
    ES256: {
        importKey: {
            name: 'ECDSA',
            namedCurve: 'P-256'
        },
        operation: {
            name: 'ECDSA',
            namedCurve: 'P-256',
            hash: 'SHA-256'
        }
    }
};
var WebCryptoJWT = /** @class */ (function () {
    function WebCryptoJWT(subtleCrypto) {
        this.subtleCrypto = subtleCrypto;
        if (!subtleCrypto)
            this.findSubtleCrypto();
    }
    WebCryptoJWT.prototype.decodeUntrusted = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var decodedToken;
            return __generator(this, function (_a) {
                decodedToken = this._decode(token);
                return [2 /*return*/, { claims: decodedToken.payload, string: token }];
            });
        });
    };
    WebCryptoJWT.prototype.findSubtleCrypto = function () {
        if ('crypto' in window)
            this.subtleCrypto = crypto.subtle || crypto['webkitSubtle'];
        if (!this.subtleCrypto && 'msCrypto' in window)
            this.subtleCrypto = window['msCrypto'].Subtle;
    };
    WebCryptoJWT.prototype.encode = function (payload, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = {};
                        return [4 /*yield*/, this._sign(payload, options.secretOrKey, this.algorithmOf(options))];
                    case 1: return [2 /*return*/, (_a.string = _b.sent(),
                            _a.claims = payload,
                            _a)];
                }
            });
        });
    };
    WebCryptoJWT.prototype.validate = function (string, options) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var decodedToken, algorithm, secretOrKey, claims, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        decodedToken = this._decode(string);
                        algorithm = this.algorithmOf(options);
                        secretOrKey = options.secretOrKey;
                        claims = decodedToken.payload;
                        // Signature must match
                        if (decodedToken.header.alg !== algorithm)
                            throw new Error("Cannot validate JWT '" + string + "': Token has incorrect algorithm");
                        _b = algorithm !== 'none';
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._verify(decodedToken, secretOrKey, algorithm)];
                    case 1:
                        _b = !(_c.sent());
                        _c.label = 2;
                    case 2:
                        if (_b)
                            throw new Error("Cannot validate JWT '" + string + "': Invalid signature");
                        // Algorithm must match
                        // Expiration
                        try {
                            common_1.validateExpiry(claims.exp, options.now, (_a = options.validate) === null || _a === void 0 ? void 0 : _a.exp);
                        }
                        catch (e) {
                            throw new Error("Cannot validate JWT '" + string + "': " + e.message);
                        }
                        return [2 /*return*/, {
                                string: string,
                                claims: decodedToken.payload
                            }];
                }
            });
        });
    };
    WebCryptoJWT.prototype.algorithmOf = function (options) {
        return options.algorithm || 'HS256';
    };
    WebCryptoJWT.prototype.str2ab = function (str) {
        var buf = new ArrayBuffer(str.length);
        var bufView = new Uint8Array(buf);
        for (var i = 0, strLen = str.length; i < strLen; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return buf;
    };
    /**
     * Adapted from https://chromium.googlesource.com/chromium/blink/+/master/LayoutTests/crypto/subtle/hmac/sign-verify.html
     *
     * @param token
     * @param secret
     * @param alg
     */
    WebCryptoJWT.prototype._verify = function (token, secret, alg) {
        return __awaiter(this, void 0, void 0, function () {
            var importAlgorithm, keyFormat, secretBuf, encoder, key, e_1, identifier, partialToken, signaturePart, messageAsUint8Array, signatureAsUint8Array, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (alg === 'none')
                            return [2 /*return*/, true];
                        importAlgorithm = ALGORITHMS[alg];
                        if (!importAlgorithm)
                            throw new Error("Algorithm " + alg + " is not supported");
                        encoder = new TextEncoder();
                        // TODO Test utf8ToUint8Array function
                        if (secret.includes('-----BEGIN PUBLIC KEY-----')) {
                            secretBuf = this.str2ab(atob(secret
                                .replace(/^-----BEGIN PUBLIC KEY-----\n/, '')
                                .replace(/\n-----END PUBLIC KEY-----/, '')
                                .replace(/\n/g, '')));
                            keyFormat = 'spki';
                        }
                        else if (secret.includes('-----BEGIN RSA PUBLIC KEY-----')) {
                            throw new Error("PKCS#1 keys are not supported. "
                                + "Please convert the key to PKCS#8 instead: "
                                + "openssl pkcs8 -topk8 -inform PEM -outform PEM -nocrypt -in pkcs1.key -out pkcs8.key");
                        }
                        else {
                            secretBuf = encoder.encode(secret);
                            keyFormat = 'raw';
                        }
                        if (!this.subtleCrypto)
                            throw new Error("Not supported: No Subtle Crypto support");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.subtleCrypto.importKey(keyFormat, secretBuf, importAlgorithm.importKey, false, ['verify'])];
                    case 2:
                        key = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        identifier = "jwtUncaughtError" + Math.floor(10000 + Math.random() * 10000);
                        console.error("JWT.verify(): Caught error while importing " + alg + " key: format=" + keyFormat + ", importAlgorithm: " + JSON.stringify(importAlgorithm.importKey) + ".");
                        console.error(e_1);
                        if (typeof window !== 'undefined') {
                            window[identifier] = e_1;
                            console.error("To aid in debugging, this error was saved to " + identifier);
                        }
                        throw e_1;
                    case 4:
                        partialToken = token.encodedHeader + "." + token.encodedPayload;
                        signaturePart = token.signature;
                        messageAsUint8Array = encoder.encode(partialToken);
                        signatureAsUint8Array = base64url_1.Base64URL.parse(signaturePart);
                        if (!this.subtleCrypto)
                            throw new Error("Not supported: No Subtle Crypto support");
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.subtleCrypto.verify(importAlgorithm.operation, key, signatureAsUint8Array, messageAsUint8Array)];
                    case 6: return [2 /*return*/, _a.sent()];
                    case 7:
                        e_2 = _a.sent();
                        console.error("JWT.verify(): Caught error while verifying token:");
                        console.error(e_2);
                        throw e_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ;
    WebCryptoJWT.prototype._sign = function (payload, secret, alg) {
        return __awaiter(this, void 0, void 0, function () {
            var importAlgorithm, payloadAsJSON, header, headerAsJSON, partialToken, keyFormat, encoder, secretBuf, key, e_3, messageAsUint8Array, signature, e_4, signatureAsBase64, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        importAlgorithm = ALGORITHMS[alg];
                        if (!importAlgorithm)
                            throw new Error("Algorithm '" + alg + "' is not supported");
                        payloadAsJSON = JSON.stringify(payload);
                        header = { alg: alg, typ: 'JWT' };
                        headerAsJSON = JSON.stringify(header);
                        partialToken = base64url_1.Base64URL.stringify(utils_1.Utils.utf8ToUint8Array(headerAsJSON)) + '.' +
                            base64url_1.Base64URL.stringify(utils_1.Utils.utf8ToUint8Array(payloadAsJSON));
                        if (alg === 'none')
                            return [2 /*return*/, partialToken + "."];
                        keyFormat = 'raw';
                        encoder = new TextEncoder();
                        // TODO Test utf8ToUint8Array function
                        if (secret.includes('-----BEGIN RSA PRIVATE KEY-----')) {
                            throw new Error("PKCS#1 keys are not supported. Please convert the key to PKCS#8 instead: openssl pkcs8 -topk8 -inform PEM -outform PEM -nocrypt -in pkcs1.key -out pkcs8.key");
                        }
                        else if (secret.includes('-----BEGIN PRIVATE KEY-----')) {
                            secretBuf = this.str2ab(atob(secret
                                .replace(/^-----BEGIN PRIVATE KEY-----\n/, '')
                                .replace(/\n-----END PRIVATE KEY-----/, '')
                                .replace(/\n/g, '')));
                            keyFormat = 'pkcs8';
                        }
                        else {
                            secretBuf = encoder.encode(secret);
                        }
                        if (!this.subtleCrypto)
                            throw new Error("Not supported: No Subtle Crypto support");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.subtleCrypto.importKey(keyFormat, secretBuf, importAlgorithm.importKey, false, ['sign'])];
                    case 2:
                        key = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        console.error("JWT.sign(): Caught error while importing " + alg + " key: format=" + keyFormat + ", importAlgorithm: " + JSON.stringify(importAlgorithm.importKey));
                        console.error(e_3);
                        throw e_3;
                    case 4:
                        messageAsUint8Array = utils_1.Utils.utf8ToUint8Array(partialToken);
                        if (!this.subtleCrypto)
                            throw new Error("Not supported: No Subtle Crypto support");
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.subtleCrypto.sign(importAlgorithm.operation, key, messageAsUint8Array)];
                    case 6:
                        signature = _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_4 = _a.sent();
                        console.error("JWT.sign(): Caught error while signing token:");
                        console.error(e_4);
                        throw e_4;
                    case 8:
                        signatureAsBase64 = base64url_1.Base64URL.stringify(new Uint8Array(signature));
                        token = partialToken + "." + signatureAsBase64;
                        return [2 /*return*/, token];
                }
            });
        });
    };
    ;
    WebCryptoJWT.prototype._decode = function (token) {
        var parts = token.split('.');
        if (parts.length !== 3)
            throw new Error("Invalid token '" + token + "': must have 3 parts separated by '.'");
        return {
            encodedHeader: parts[0],
            encodedPayload: parts[1],
            signature: parts[2],
            header: JSON.parse(this._decodeBase64URL(parts[0])),
            payload: JSON.parse(this._decodeBase64URL(parts[1])),
        };
    };
    ;
    WebCryptoJWT.prototype._decodeBase64URL = function (string) {
        string = string.replace(/-/g, '+').replace(/_/g, '/');
        switch (string.length % 4) {
            case 0:
                break;
            case 2:
                string += '==';
                break;
            case 3:
                string += '=';
                break;
            default:
                throw new Error("Illegal Base64URL string '" + string + "'");
        }
        // TODO Use shim or document incompatible browsers
        return decodeURIComponent(escape(atob(string)));
    };
    return WebCryptoJWT;
}());
exports.WebCryptoJWT = WebCryptoJWT;
//# sourceMappingURL=webcrypto-jwt.js.map